export default __webpack_public_path__ + "static/media/blog01.43d140da.jpg";